import { LogFormatter } from '../log-publisher';

export const simpleFormatter: LogFormatter = record => {
  const date = record.date.toISOString();
  return `${date} ${record.getLevelName()} ${record.message}`;
};
